import { Sort } from "@planzone/dto";
import { Identifiable, SecondaryCriteria } from "@planzone/dto";

function isCustomCriteria(
  columnKey: string,
  template: Identifiable<SecondaryCriteria>[],
): boolean {
  return template.some(({ uuid }) => uuid === columnKey);
}

function buildCustomSort(columnKey: string, direction: "asc" | "desc"): Sort {
  return `customCriteria:${columnKey}:${direction}` as Sort;
}

function isCustomSort(sort: Sort): boolean {
  return sort.startsWith("customCriteria:");
}

export { isCustomCriteria, buildCustomSort, isCustomSort };
